export default "assets/images/footer-partners-logos-f792ffb6.png";